"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.documentFromFile = void 0;

var path = _interopRequireWildcard(require("path"));

var documentFromFile = function documentFromFile(file) {
  return {
    fileName: file.name,
    extension: path.extname(file.name),
    mimeType: file.type,
    fileSize: file.size,
    createdAt: new Date().toString() // Not the time when the file was created at.

  };
};

exports.documentFromFile = documentFromFile;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlsaXRpZXMvZG9jdW1lbnQudHMiXSwibmFtZXMiOlsiZG9jdW1lbnRGcm9tRmlsZSIsImZpbGUiLCJmaWxlTmFtZSIsIm5hbWUiLCJleHRlbnNpb24iLCJwYXRoIiwiZXh0bmFtZSIsIm1pbWVUeXBlIiwidHlwZSIsImZpbGVTaXplIiwic2l6ZSIsImNyZWF0ZWRBdCIsIkRhdGUiLCJ0b1N0cmluZyJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUE7O0FBSU8sSUFBTUEsZ0JBQWdCLEdBQUcsU0FBbkJBLGdCQUFtQixDQUFDQyxJQUFEO0FBQUEsU0FBMEM7QUFDeEVDLElBQUFBLFFBQVEsRUFBRUQsSUFBSSxDQUFDRSxJQUR5RDtBQUV4RUMsSUFBQUEsU0FBUyxFQUFFQyxJQUFJLENBQUNDLE9BQUwsQ0FBYUwsSUFBSSxDQUFDRSxJQUFsQixDQUY2RDtBQUd4RUksSUFBQUEsUUFBUSxFQUFFTixJQUFJLENBQUNPLElBSHlEO0FBSXhFQyxJQUFBQSxRQUFRLEVBQUVSLElBQUksQ0FBQ1MsSUFKeUQ7QUFLeEVDLElBQUFBLFNBQVMsRUFBRSxJQUFJQyxJQUFKLEdBQVdDLFFBQVgsRUFMNkQsQ0FLdEM7O0FBTHNDLEdBQTFDO0FBQUEsQ0FBekIiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgKiBhcyBwYXRoIGZyb20gJ3BhdGgnO1xuXG5pbXBvcnQgeyBTZWN1cmVEb2N1bWVudCB9IGZyb20gJy4uL3NoYXJlZCc7XG5cbmV4cG9ydCBjb25zdCBkb2N1bWVudEZyb21GaWxlID0gKGZpbGU6IEZpbGUpOiBQYXJ0aWFsPFNlY3VyZURvY3VtZW50PiA9PiAoe1xuICBmaWxlTmFtZTogZmlsZS5uYW1lLFxuICBleHRlbnNpb246IHBhdGguZXh0bmFtZShmaWxlLm5hbWUpLFxuICBtaW1lVHlwZTogZmlsZS50eXBlLFxuICBmaWxlU2l6ZTogZmlsZS5zaXplLFxuICBjcmVhdGVkQXQ6IG5ldyBEYXRlKCkudG9TdHJpbmcoKSwgLy8gTm90IHRoZSB0aW1lIHdoZW4gdGhlIGZpbGUgd2FzIGNyZWF0ZWQgYXQuXG59KTtcbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ./~/@mhub/securedocuments-sdk-js/dist/utilities/document.js
// module id = 1838
// module chunks = 0